<template>
  <div>
    <!-- Page Header -->
    <div class="mb-5">
      <div class="headline saPrimary--text">
        {{ $t("company.participants.list.title") }}
      </div>
      <span class="body-1 greyDarken3--text">{{
        $t("company.participants.list.subtitle")
      }}</span>
      <!-- <v-spacer></v-spacer>
        <v-btn @click="exportAllConsumersReport()" color="primary">
          <v-icon small class="pr-1">$vuetify.icons.rms_media_download</v-icon>
          {{ $t("company.consumer.details.export") }}
        </v-btn> -->
    </div>

    <v-card>
      <v-card-title>
        <div v-if="total" class="title">
          <span>Total : </span>
          <b>{{ total }}</b>
        </div>
        <v-spacer></v-spacer>
        <v-text-field
          class="custom-placeholer-color"
          append-outer-icon="search"
          v-model="search"
          label="Search"
          :placeholder="'Search by name, email or id'"
          clear-inner-icon="rms_close"
          clearable
          single-line
          hide-details
          @keyup.enter="getAllConsumersFromApi"
          @click:clear="clearSearch"
          @click:append-outer="applySearch"
          color="saSecondary"
        ></v-text-field>
      </v-card-title>
      <v-data-table
        v-if="consumers"
        :headers="table_headers"
        :items="consumers"
        :loading="loading"
        :pagination.sync="pagination"
        :total-items="total"
        :rowsPerPageItems="rowsPerPageItems"
        item-key="id"
      >
        <!-- <template v-slot:headers="props">
          <tr>
            <th>
              <v-checkbox
                :input-value="props.all"
                :indeterminate="props.indeterminate"
                primary
                hide-details
                @click.stop="toggleAll"
              ></v-checkbox>
            </th>
            <th
              v-for="header in props.headers"
              :key="header.text"
              :class="['text-xs-left']"
            >{{ header.text }}</th>
          </tr>
        </template>-->
        <template v-slot:items="props">
          <tr>
            <td width="6%">{{ props.item.id }}</td>
            <td>
              <span v-if="props.item.name">{{ props.item.name }}</span>
              <span v-else>-</span>
            </td>
            <td>{{ props.item.email }}</td>
            <td>{{ props.item.phone }}</td>
            <td>
              <v-icon color="success" v-if="props.item.is_verified"
                >$vuetify.icons.rms_check</v-icon
              >
              <v-icon color="error" v-else>$vuetify.icons.rms_close</v-icon>
            </td>
            <td width="15%">
              {{ moment(props.item.created_at).format("DD MMM YYYY, HH:MM") }}
            </td>
            <td width="15%">
              <ConfirmationDialog
                :desc="'screener.registrant.remove.confirmation.description'"
                :action='getDialogAction(
                    props.item.id,
                    "rms_delete",
                    "error",
                  )'
                :headline="'screener.registrant.remove.confirmation.heading'"
                :button_type="'icon'"
              ></ConfirmationDialog>
            </td>
            <!-- <td width="15%">
              <v-tooltip slot="append" top color="white">
                <v-btn
                  slot="activator"
                  icon
                  small
                  dark
                  :to="{
                    name: 'consumer.index',
                    params: { consumer_id: props.item.id },
                  }"
                >
                  <v-icon color="primary">$vuetify.icons.rms_visibility</v-icon>
                </v-btn>
                <span class="greyDarken3--text body-1">{{
                  $t("company.consumer.details.form.btn.show.details")
                }}</span>
              </v-tooltip>
              <v-tooltip slot="append" top color="white">
                <v-btn
                  slot="activator"
                  icon
                  small
                  dark
                  @click="showPassword(props.item.id)"
                >
                  <v-icon color="secondary">$vuetify.icons.rms_password</v-icon>
                </v-btn>
                <span class="greyDarken3--text body-1">{{
                  $t("screener.tooltip.show_password")
                }}</span>
              </v-tooltip>

              <ConfirmationDialog
                :desc="'screener.registrant.remove.confirmation.description'"
                :action="
                  getDialogAction(
                    props.item.id,
                    'rms_delete',
                    'error',
                    'delete',
                  )
                "
                :headline="'screener.registrant.remove.confirmation.heading'"
                :button_type="'icon'"
              ></ConfirmationDialog>
            </td> -->
          </tr>
        </template>
      </v-data-table>
      <v-dialog v-model="showPasswordDialog" max-width="350">
        <v-card>
          <v-card-title class="headline">{{
            $t("screener.consumer.password.title")
          }}</v-card-title>
          <v-card-text v-if="consumerPassword" class="text-xs-center">
            <div class="headline">{{ consumerPassword }}</div>
          </v-card-text>
          <v-card-text v-else>{{
            $t("screener.save.password_not_generated")
          }}</v-card-text>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="lightteal"
              dark
              outline
              @click="
                $copyText(consumerPassword);
                showPasswordDialog = false;
                consumerPassword = null;
              "
              >{{ $t("screener.btn.copy") }}</v-btn
            >
            <v-btn
              color="lightteal"
              dark
              outline
              @click="
                showPasswordDialog = false;
                consumerPassword = null;
              "
              >{{ $t("screener.btn.ok") }}</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-card>
  </div>
</template>

<script>
import ConfirmationDialog from "@/components/ConfirmationDialog";
import i18n from "@/i18n";
import { mapGetters } from "vuex";
import { mapFields } from "vuex-map-fields";
import rules from "@/validation";

export default {
  name: "AdminConsumerList",
  async beforeRouteEnter(to, from, next) {
    await next((vm) => {
      vm.getAllConsumersFromApi();
    });
  },
  data() {
    return {
      rules,
      table_headers: [
        {
          text: "Participant ID",
          sortable: true,
          align: "left",
          value: "id",
        },
        {
          text: "Name",
          sortable: true,
          align: "left",
          value: "name",
        },
        {
          text: "Email",
          sortable: true,
          align: "left",
          value: "email",
        },
        {
          text: "Phone",
          sortable: false,
          align: "left",
          value: "phone",
        },
        {
          text: "Verified",
          sortable: true,
          align: "left",
          value: "is_verified",
        },
        {
          text: "Created At",
          align: "left",
          sortable: true,
          value: "created_at",
        },
        {
          text: "Action",
          align: "left",
          value: "delete",
          sortable: false,
        },
      ],
      createDialog: false,
      consumer_email: null,
      search: "",
      confirmation: false,
      deleteAllConfirmation: false,
      showPasswordDialog: false,
      loading: false,
      consumer_id: null,
      rowsPerPageItems: [5, 10, 25, 50, 100],
      pagination: {
        sortBy: "created_at",
        descending: true,
        rowsPerPage: 10,
        page: 1,
      },
      total: 0,
      selected: [],
      consumerPassword: null,
      screening_attended_count: null,
      total_purchased_count: null,
      total_enrolled_count: null,
    };
  },
  components: { ConfirmationDialog },
  watch: {
    pagination: {
      handler() {
        this.getAllConsumersFromApi();
      },
      deep: true,
    },
  },
  computed: {
    ...mapGetters({
      isSuperAdmin: "user/isSuperAdmin",
    }),
    ...mapGetters("adminConsumer", {
      consumers: "list",
    }),
  },
  methods: {
    applySearch() {
      if (this.search.length) this.getAllConsumersFromApi();
    },
    clearSearch() {
      this.search = null;
      this.getAllConsumersFromApi();
    },
    async getAllConsumersFromApi() {
      this.loading = true;
      const { sortBy, descending, page, rowsPerPage } = this.pagination;
      var offset = this.getPaginationOffset(rowsPerPage, page);

      // Payload
      let payload = {
        offset: offset,
        limit: rowsPerPage,
        sort: sortBy,
        sorting_order: descending,
        search: this.search,
      };

      try {
        var result = await this.$store.dispatch(
          "adminConsumer/getAllConsumerList",
          payload
        );
        this.total = result.consumers.total;
      } catch (error) {                                         
        this.$store.dispatch("app/showMessage", {
          message: error.message,
          color: this.DEFINES.SNACKBAR_ERROR_COLOR,
        });
      }
      this.loading = false;
    },
    async remove(consumer_id) {
      try {
        var result = await this.$store.dispatch("consumer/detachConsumer", {
          consumer_id: consumer_id,
          screener_id: this.$route.params.screener_id,
        });
        this.$store.dispatch("app/showMessage", {
          message: "Registrant removed successfully",
          color: this.DEFINES.SNACKBAR_SUCCESS_COLOR,
        });
        this.getAllConsumersFromApi();      
      } catch (error) {
        this.$store.dispatch("app/showMessage", {
          message: error.message,
          color: this.DEFINES.SNACKBAR_ERROR_COLOR,
        });
      } finally {
        this.confirmation = false;
      }
    },
    async deleteAll() {
      try {
        var result = await this.$store.dispatch("consumer/detachAllConsumer", {
          screener_id: this.$route.params.screener_id,
        });
        this.$store.dispatch("app/showMessage", {
          message: "Registrants removed successfully",
          color: this.DEFINES.SNACKBAR_SUCCESS_COLOR,
        });
        this.getAllConsumersFromApi();
      } catch (error) {
        this.$store.dispatch("app/showMessage", {
          message: error.message,
          color: this.DEFINES.SNACKBAR_ERROR_COLOR,
        });
      } finally {
        this.confirmation = false;
      }
    },

    getPaginationOffset: (recordPerPage, page) => recordPerPage * (page - 1),
    async showPassword(consumer_id) {
      try {
        this.consumerPassword = null;
        var result = await this.$store.dispatch("consumer/showPassword", {
          id: consumer_id,
        });

        this.consumerPassword = result.password;
        this.showPasswordDialog = true;
      } catch (error) {
        this.$store.dispatch("app/showMessage", {
          message: error.message,
          color: this.DEFINES.SNACKBAR_ERROR_COLOR,
        });
      }
    },

    async sendVerificationsEmails() {
      // try {
      //   var result = await this.$store.dispatch(
      //     "customer/sendVerificationsEmails",
      //     {
      //       customers: this.getSelectedConsumerIds(this.selected),
      //       screener_id: this.$route.params.screener_id
      //     }
      //   );
      //   this.$store.dispatch("app/showMessage", {
      //     message: i18n.t(
      //       "screener.customers.send.verification.success.message"
      //     ),
      //     color: this.DEFINES.SNACKBAR_SUCCESS_COLOR
      //   });
      // } catch (error) {
      //   this.$store.dispatch("app/showMessage", {
      //     message: error.message,
      //     color: this.DEFINES.SNACKBAR_ERROR_COLOR
      //   });
      // }
    },

    async sendReminders() {
      try {
        var result = await this.$store.dispatch("consumer/sendReminders", {
          consumers: this.getSelectedConsumerIds(this.selected),
          screener_id: this.$route.params.screener_id,
        });
        this.$store.dispatch("app/showMessage", {
          message: i18n.t("screener.consumers.send.reminder.success.message"),
          color: this.DEFINES.SNACKBAR_SUCCESS_COLOR,
        });
      } catch (error) {
        this.$store.dispatch("app/showMessage", {
          message: error.message,
          color: this.DEFINES.SNACKBAR_ERROR_COLOR,
        });
      }
    },

    async create() {
      try {
        if (!this.$refs.consumerForm.validate()) {
          return false;
        }
        var result = await this.$store.dispatch("consumer/createByAdmin", {
          screener_id: this.$route.params.screener_id,
          email: this.consumer_email,
        });
        this.getAllConsumersFromApi();
      } catch (error) {
        this.$store.dispatch("app/showMessage", {
          message: error.message,
          color: this.DEFINES.SNACKBAR_ERROR_COLOR,
        });
      } finally {
        this.createDialog = false;
      }
    },

    async download() {
      try {
        var result = await this.$store.dispatch(
          "screener/downloadAllConsumers",
          {
            screener_id: this.$route.params.screener_id,
          }
        );
        window.open(result.link, "_blank");
      } catch (error) {
        this.$store.dispatch("app/showMessage", {
          message: error.message,
          color: this.DEFINES.SNACKBAR_ERROR_COLOR,
        });
      }
    },

    toggleAll() {
      if (this.selected.length) this.selected = [];
      else this.selected = this.consumers.data.slice();
    },
    getSelectedConsumerIds(selected_consumers) {
      return selected_consumers.map((consumer) => consumer.id);
    },

    openCreateDialog() {
      this.createDialog = true;
      this.consumer_email = null;
    },

    getDialogAction(
      consumer_id = null,
      btn_icon,
      btn_color,
      btn_lable
    ) {
      return {
        button_icon: btn_icon,
        button_color: btn_color,
        button_label: btn_lable,
        no_outline: true,
        method: this.deleteConsumerDetails,
        payload: consumer_id,
      };
    },

    async exportAllConsumersReport() {
      this.$store
        .dispatch("consumer/exportAllConsumersReport")
        .then((response) => {
          this.$store.dispatch("app/showMessage", {
            message: i18n.t("screener.consumer.report_email.msg"),
            color: "success",
          });
        })
        .catch((error) => {
          this.$store.dispatch("app/showMessage", {
            message: error.message,
            color: "error",
          });
        });
    },

    async deleteConsumerDetails(consumer_id) {
      await this.$store
        .dispatch("adminConsumer/deleteConsumerDetails", {
          id: consumer_id,
        })
        .then((response) => {
          this.$store.dispatch("app/showMessage", {
            message: i18n.t("screener.consumer.deleted_details_successfully"),
            color: "success",
          });

          this.getAllConsumersFromApi();
        })
        .catch((error) => {
          this.$store.dispatch("app/showMessage", {
            message: error.message,
            color: "error",
          });
        });
    },
  },
};
</script>
